import { render, staticRenderFns } from "./PlaidLink.vue?vue&type=template&id=4c0a21e0&"
import script from "./PlaidLink.vue?vue&type=script&lang=js&"
export * from "./PlaidLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports